export class Field {
  constructor({
    id,
    name,
    status,
    isPublic,
    type,
    surface,
    capacity,
    description,
    address,
    city,
    state,
    country,
    zip,
    lat,
    long,
    pricePlaceholder,
    availabilityPlaceholder,
    imagePath,
    operatorID,
    timezone,
    effectivePrice,
    rateType
  }) {
    this.id = id;
    this.name = name;
    this.status = status;
    this.isPublic = isPublic;
    this.type = type;
    this.surface = surface;
    this.city = city;
    this.state = state;
    this.zip = zip;
    this.country = country;
    this.capacity = capacity;
    this.description = description;
    this.address = `${address}, ${city}, ${state}, ${zip}, ${country}`;
    this.lat = parseFloat(lat);
    this.long = parseFloat(long);
    this.pricePlaceholder = pricePlaceholder;
    this.availabilityPlaceholder = availabilityPlaceholder;
    this.imagePath = imagePath;
    this.operatorID = operatorID;
    this.timezone = timezone || 'America/New_York'; // Default timezone
    this.effectivePrice = effectivePrice;
    this.rateType = rateType;
  }

  static fromListing(item, extra = {}) {
    return new Field({
      id: item.listingID,
      name: item.listingName,
      status: item.listingStatus,
      isPublic: item.listingPublic,
      type: item.listingType,
      surface: item.listingSurface,
      capacity: item.listingCapacity,
      description: item.listingDescription,
      address: item.listingAddress,
      city: item.listingCity,
      state: item.listingState,
      country: item.listingCountry,
      zip: item.listingZIP,
      lat: item.listingLat,
      long: item.listingLong,
      pricePlaceholder: item.listingPricePlaceholder,
      availabilityPlaceholder: item.listingAvailabilityPlaceholder,
      imagePath: item.listingImagePath,
      operatorID: item.operatorID,
      timezone: item.listingTimezone,
      ...extra,
    });
  }

  isVisible() {
    return (this.status === 'active' || this.status === 'contact-only') && this.isPublic;
  }

  isBookable() {
    return this.status === 'active';
  }

  isContactOnly() {
    return this.status === 'contact-only';
  }

  getFormattedPrice() {
    const price = parseFloat(this.pricePlaceholder);
    return isNaN(price) ? '$0.00' : `$${price.toFixed(2)}`;
  }

  // Pure function: Depends entirely on the `userLocation` passed in
  getFormattedDistance(userLocation) {
    if (!userLocation || !userLocation.lat || !userLocation.long) {
      return ''; // Return empty string if no location (cleaner UI)
    }

    const distance = this.calculateDistance(userLocation.lat, userLocation.long);
    return `${distance.toFixed(1)} miles`;
  }

  calculateDistance(targetLat, targetLong) {
    if (!this.lat || !this.long) return 0;

    const toRad = (value) => (value * Math.PI) / 180;
    const R = 3958.8; // Radius of Earth in Miles

    const dLat = toRad(targetLat - this.lat);
    const dLong = toRad(targetLong - this.long);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(this.lat)) *
      Math.cos(toRad(targetLat)) *
      Math.sin(dLong / 2) *
      Math.sin(dLong / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }
}